<template>
    <div
        class="aup-public-profile__gallery-container"
        :class="{ 'aup-public-profile__gallery-container--showing-more': isShowingMorePhotos }"
        ref="galleryContainer"
		:style="paddingTopStyle"
        :key="componentKey"
    >
		<div
            class="d-flex justify-content-center align-items-center"
            v-if="isLoading"

        >
            <BaseBoxLoader />
        </div>
        <div v-if="!isLoading" class="public-profile__image-container" ref="imageContainer">
            <div class="aup-public-profile__gallery-container-item" v-images-loaded:on.progress="imageProgress">
                <div
                    class="row"
                    v-masonry
                    item-selector=".aup-public-profile__gallery-item"
                    id="gallery-vue-container"
                >
                    <div
                        v-masonry-tile
                        class="aup-public-profile__gallery-item col-md-6 col-xl-4"
                        v-for="item in galleryItems"
                        :key="item.ppd_usermediaid"
                    >
                        <BaseVideoCard
                                v-if="item.ppd_mediatype === mediaTypes['Video']"
                                :videoUrl="item.ppd_videourl"
                                :videoOptions="item.ppd_videooptions"
                                :thumbnail="item.ppd_imageurl"
                                @click.native="showVideoPlayer(item)"
                        />

                        <BasePhotoCard
                            v-else
                            :alt="item.alt"
                            :photoLikes="item.ppd_photolikes"
                            :title="item.ppd_displaytitle"
                            :cameraMake="item.ppd_cameramake"
                            :cameraModel="item.ppd_cameramodel"
                            :lensModel="item.ppd_lensmodel"
                            :imageZestyGuid="item.ppd_zestyguid"
                            :imageURL="item.ppd_imageurl"
                            @click.native="showPhotoDetails(item)"
                            :userName="userName"
                            :imageGUID="item.ppd_usermediaid"
                            :verifiedSonyPhoto="item.ppd_sonyverified && String(item.ppd_cameramake).toLowerCase() === 'sony'"
                            :isSelfProfile="isSelfProfile"
                            :isLiked="item.isLiked"
                            :loggedIn="loggedIn"
                            :equipment="equipment"
                        />


                    </div>
                </div>
            </div>
        </div>
        <div
            class="d-flex w-100 justify-content-center aup-public-profile__gallery-container__show-more"
            v-if="isShowingMorePhotos && !displayShowMoreButton && !showAllPhotosAtOnce"
        >
            <div class="py-4">
                <BaseButton
                    class
                    @click="isShowingMorePhotos = false;"
                    color="orange"
                    :filled="true"
                >Show Fewer Photos</BaseButton>
            </div>
        </div>
        <div
            class="d-flex w-100 justify-content-center aup-public-profile__gallery-container__show-more"
            v-else-if="displayShowMoreButton"
        >
            <div class="py-4">
                <BaseButton
                    class
                    @click="isShowingMorePhotos = true"
                    color="orange"
                    :filled="true"
                >Show More Photos</BaseButton>
            </div>
        </div>
        <BaseModalPhoto
            v-model="showModal"
            :modalBgGuid="selectedCard.ppd_zestyguid"
            :modalBgUrl="selectedCard.ppd_imageurl"
        >
            <div slot="content">
                <BasePhotoDetails
					:alt="selectedCard.alt"
					:isSelfProfile="isSelfProfile"
                    :photoTitle="selectedCard.ppd_displaytitle"
					:photoDescription="selectedCard.ppd_displaydescription"
                    :name="userName"
                    :dateTaken="selectedCard.ppd_datetaken"
                    :location="selectedCard.ppd_locationtaken"
                    v-on:close="showModal = false"
                    :cameraMake="selectedCard.ppd_cameramake"
                    :cameraModel="selectedCard.ppd_cameramodel"
                    :lensModel="selectedCard.ppd_lensmodel"
                    :staffPick="selectedCard.ppd_isstaffpick"
                    :focalLength="selectedCard.ppd_focallength"
                    :fStop="selectedCard.ppd_fnumber"
                    :exposure="selectedCard.ppd_exposuretime"
                    :ISO="selectedCard.ppd_iso"
                    :imageZestyGuid="selectedCard.ppd_zestyguid"
                    :imageURL="selectedCard.ppd_imageurl"
                    :categoryTags="selectedCard.ppd_categorytags"
                    :imageGUID="selectedCard.ppd_usermediaid"
                    :photoShares="selectedCard.ppd_communityreactiontwocount"
                    :photoLikes="selectedCard.ppd_photolikes"
                    :verifiedSonyPhoto="selectedCard.ppd_sonyverified && String(selectedCard.ppd_cameramake).toLowerCase() === 'sony'"
                    :reportItemGuid="selectedCard.ppd_usermediaid"
                    :isLiked="selectedCard.isLiked"
                    :equipment="equipment"
                    :utmCodesUsage="'profile_gallery_image'"
                />
            </div>
        </BaseModalPhoto>

        <BaseModalVideo
                v-model="showVideoModal"
                :modalBgUrl="selectedCard.ppd_imageurl"
                :videoOptions="selectedCard.ppd_videooptions"
                :videoUrl="selectedCard.ppd_videourl"
                @close="showVideoModal = false"
        >
        </BaseModalVideo>
    </div>
    <!--TODO fix the above userName to be the persons username on the profile entity-->
</template>
<script>
import BasePhotoCard from '@/components/global/BasePhotoCard';
import BaseModalPhoto from '@/components/global/BaseModalPhoto.vue';
import BasePhotoDetails from '@/components/global/BasePhotoDetails';
import BaseButton from '@/components/global/BaseButton';
import BaseVideoCard from '@/components/global/BaseVideoCard';
import { mapState } from 'vuex';
import imagesLoaded from 'vue-images-loaded';
import DYNAMICS_ENTITIES from "@/PROFILE_CONSTANTS/DYNAMICS_ENTITIES";

export default {
	name: 'Gallery',
	directives: {
		imagesLoaded
	},
    computed: {
        galleryItems: {
			cache: false,
            get() {
				let userMediaExcludeProfilePic = [];
				let userMediaArray = [];
                userMediaArray = this.$store.state.Public.galleryMedia;
                if (userMediaArray) {
                    // loop through usermedia and return all photos that arent profilePicture
                    const userMediaExcludeProfilePic = userMediaArray.filter(
                        media => {
                            return media.ppd_isprofile != true;
                        }
					);

					// this.isLoading = false;
                    return userMediaExcludeProfilePic;
                } else {
                    return;
				}
			},
        },
        paddingTopStyle: function () {
            let paddingValue = 82;
            if(this.heroBoxIsEmpty){
                if(this.w <= 768) {
                    paddingValue = 41;
                } else {
                    paddingValue = 82;
                }
            } else {
                paddingValue = 82;
            }
            return `padding-top: ${paddingValue}px;`;
        },
	},
    components: {
        BasePhotoCard,
        BaseModalPhoto,
        BasePhotoDetails,
        BaseButton,
        BaseVideoCard,
    },
    props: {
		heroBoxIsEmpty: {
			type: Boolean,
			default: false,
		},
        userName: {
            type: String,
            default: '',
		},
		isSelfProfile: {
			type: Boolean,
			required: true,
		},
        equipment: {
            type: Object,
            default: () => {}
        },
        showAllPhotosAtOnce: {
            type: Boolean,
			default: true,
        },
    },
    data() {
        return {
            showModal: false,
            selectedCard: {},
            isShowingMorePhotos: this.showAllPhotosAtOnce,
            displayShowMoreButton: false,
            loggedIn: false,
            siblingUpdate: 0,
			componentKey: 'initial',
			isLoading: true,
			local_galleryItems: [],
            imagesLoaded:0,
            w: window.innerWidth,
            showVideoModal: false,
            mediaTypes:DYNAMICS_ENTITIES.MEDIA_TYPES,
        };
    },
    mounted() {
		this.isLoading = true;
		this.onLoad();
        if ($cookies.isKey('au_guid')) {
            this.userGUID = $cookies.get('au_profile_guid');
            this.loggedIn = true;
        } else {
            this.loggedIn = false;
        }
        // if height of image container is greater than gallery container then displayShowMoreButton should be true so user can click to see more
		// dl: TODO: replace setTimeout with adding this function to the end of the masonry layoutComplete
		setTimeout(() => {
			this.checkIfShowMoreButtonIsNeeded();
		}, 1000);
	},
    methods: {
		async onLoad(){
			await this.sleep(500);
			this.$redrawVueMasonry();
			this.isLoading = false;
		},
		sleep(ms){
			return new Promise(resolve => setTimeout(resolve, ms));
		},
        imageProgress(instance, image ) {
			const result = image.isLoaded ? 'loaded' : 'broken';
			console.info('image is ' + result + ' for ' + image.img.src);
            this.imagesLoaded++;

            if(this.galleryItems && this.imagesLoaded === this.galleryItems.length){
                 console.info('all images loaded');
                 setTimeout(() => {
                     this.$redrawVueMasonry();
                     console.info('redraw called');
                 }, 250);
             }

		},
        showPhotoDetails(photoData) {
            this.showModal = true;
            this.selectedCard = photoData;
            this.$redrawVueMasonry();
        },
        showVideoPlayer(video) {
            this.showVideoModal = true;
            this.selectedCard = video;
            this.$redrawVueMasonry();
        },
		checkIfShowMoreButtonIsNeeded() {
            if (this.$refs.imageContainer && this.$refs.imageContainer.clientHeight >= this.$refs.galleryContainer.clientHeight) {
                this.displayShowMoreButton = true;
            } else {
                this.displayShowMoreButton = false;
            }
            window.requestAnimationFrame(this.checkIfShowMoreButtonIsNeeded);
        },
    },
};
</script>



<style lang="scss">
@import '../../assets/scss/all';
.aup-public-profile {
    &__gallery-container {
		min-height: 30vh;
        max-height: 160vh;
        transition: height 0.3s ease;
        overflow: hidden;
		padding-bottom: 80px;
        &--showing-more {
            max-height: 100% !important;
            margin-bottom: 92px;
        }
        &__show-more {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: map-get($zindices, fixed);
            padding-top: 60px;
        }
    }
    &__gallery-item {
        margin-bottom: 2rem;
    }
}
</style>
